// i18n
import translations from './i18n.json';
import { translateInComponent } from 'infras/i18n';

import styled from '@emotion/styled';
import ServicePageTemplate from 'presentations/views/components/templates/ServicePageTemplate';
import ContentItem1 from 'presentations/views/components/molecules/ServiceContentItem1';
import ContentItem2 from 'presentations/views/components/molecules/ServiceContentItem2';
import ServiceSubSectionTitle from 'presentations/views/components/molecules/ServiceSubSectionTitle';
import Header from 'presentations/views/components/organisms/Header';
import { ViewerItem } from 'presentations/api/schema/user';
import { mediaMax, spacing } from 'presentations/views/styles';
import MainVisual from 'presentations/views/components/organisms/service/MainVisual';
import OddSectionContainer from 'presentations/views/components/organisms/service/OddSectionContainer';
import ImageSectionContainer from 'presentations/views/components/organisms/service/ImageSectionContainer';
import ReviewList from 'presentations/views/components/organisms/service/ServiceReviewList';
import { gray03 } from 'presentations/views/styles/color';

interface Props {
  viewer: ViewerItem | null;
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);
  return (
    <ServicePageTemplate
      isVisibleSupport={true}
      header={<Header viewer={props.viewer} />}
      breadcrumbs={[]}
    >
      <MainVisual
        title={t('title')}
        description={t('description')}
        viewer={props.viewer}
        image={{
          url: 'pages/features/meeting/device.png',
          width: 600,
          height: 400,
        }}
        // onClickInquiry={onClickInquiry}
      />
      <OddSectionContainer>
        <ImageSectionContainer>
          <SectionContainer>
            <ContentItem1
              direction="odd"
              imageUrl="pages/features/meeting/Image-5.png"
              imageWidth={537}
              imageHeight={400}
              title={t('item 1 title')}
              description={t('item 1 description')}
            />
          </SectionContainer>
        </ImageSectionContainer>
      </OddSectionContainer>
      <ImageSectionContainer>
        <SectionContainer>
          <ContentItem1
            imageUrl="pages/features/meeting/workflow02.png"
            imageWidth={537}
            imageHeight={400}
            title={t('item 2 title')}
            description={t('item 2 description')}
          />
        </SectionContainer>
      </ImageSectionContainer>

      <OddSectionContainer>
        <ImageSectionContainer>
          <SectionContainer>
            <SubSectionTitle title={t('section 1 title')} />
            <ListContainer2>
              <ListItem2>
                <ContentItem2
                  imageUrl="pages/features/meeting/Image-4.png"
                  imageWidth={440}
                  imageHeight={288}
                  icon="calendar-sync"
                  title={t('item 3 title')}
                  description={t('item 3 description')}
                />
              </ListItem2>
              <ListItem2>
                <ContentItem2
                  imageUrl="pages/features/meeting/Image-3.png"
                  imageWidth={440}
                  imageHeight={288}
                  icon="cursor-default-click"
                  title={t('item 4 title')}
                  description={t('item 4 description')}
                />
              </ListItem2>
            </ListContainer2>
          </SectionContainer>
        </ImageSectionContainer>
      </OddSectionContainer>
      <ImageSectionContainer>
        <SectionContainer>
          <ContentItem1
            direction="odd"
            imageUrl="pages/features/meeting/Image-2.png"
            imageWidth={537}
            imageHeight={400}
            title={t('item 5 title')}
            description={t('item 5 description')}
          />
        </SectionContainer>
      </ImageSectionContainer>
      <OddSectionContainer>
        <ImageSectionContainer>
          <SectionContainer>
            <ContentItem1
              imageUrl="pages/features/meeting/Image.png"
              imageWidth={537}
              imageHeight={400}
              title={t('item 7 title')}
              description={t('item 7 description')}
            />
          </SectionContainer>
        </ImageSectionContainer>
      </OddSectionContainer>
      <ReviewListContainer>
        <ReviewList />
      </ReviewListContainer>
    </ServicePageTemplate>
  );
}

const SectionContainer = styled.div`
  max-width: 960px;
  margin: 0 auto;
  padding: ${spacing(32)} 0;
  ${mediaMax.tablet} {
    padding: 0;
  }
`;

const ListContainer2 = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  ${mediaMax.tablet} {
    width: auto;
    display: block;
  }
`;

const ListItem2 = styled.div`
  width: 48%;
  ${mediaMax.tablet} {
    width: 100%;
  }
`;

const SubSectionTitle = styled(ServiceSubSectionTitle)`
  margin-bottom: ${spacing(32)};
`;

const ReviewListContainer = styled.div`
  max-width: 960px;
  margin: 0 auto;
  padding: ${spacing(80)} ${spacing(16)};
  border-top: 1px solid ${gray03};
  border-bottom: 1px solid ${gray03};
  ${mediaMax.tablet} {
    padding: ${spacing(40)} ${spacing(12)};
  }
`;
